const Vue = require('vue');
// import VueRouter from 'vue-router';
const VueRouter = require('vue-router');
import privacy from './views/privacy.vue';
import userprotocol from './views/userprotocol.vue';
import home from './views/home.vue';
import qanda from './views/qanda.vue';
import control from './views/control.vue';
import memberAgreement from './views/agreements/yuanshou-na/member-service.vue';
import privacyPolicy from './views/agreements/yuanshou-na/privacy-policy.vue';
import qimiaoUserAgreement from './views/agreements/qimiao-xiangce/user-agreement.vue';
import yingchuanUserAgreement from './views/agreements/yingchuan/user-agreement.vue';
import App from './App.vue';

// 管理端（独立模块，后续可整体剥离）
import { adminRoutes } from './admin';
import auth from './admin/auth';

Vue.use(VueRouter);

const routes = [
    ...adminRoutes,
    { path: '/', name: 'home', component: home },
    { path: '/privacy', name: 'privacy', component: privacy },
    { path: '/userprotocol', name: 'userprotocol', component: userprotocol},
    { path: '/qanda', name: 'qanda', component: qanda},
    { path: '/control', name: 'control', component: control },
    { path: '/member-agreement', name: 'memberAgreement', component: memberAgreement, meta: { hideChrome: true, title: '元收纳 · 会员服务协议' } },
    { path: '/privacy-policy', name: 'privacyPolicy', component: privacyPolicy, meta: { hideChrome: true, title: '元收纳 · 用户隐私政策' } },
    { path: '/qimiao-xiangce/user-agreement', name: 'qimiaoUserAgreement', component: qimiaoUserAgreement, meta: { hideChrome: true, title: '笔记相册 · 用户协议' } },
    { path: '/yingchuan/user-agreement', name: 'yingchuanUserAgreement', component: yingchuanUserAgreement, meta: { hideChrome: true, title: '影传 · 用户协议' } },
  ]

const router = new VueRouter({
  mode: 'history', // 使用 HTML5 历史模式，可以去掉 URL 中的 #
  base: process.env.BASE_URL,
  routes,
});

// 管理端登录守卫：需要鉴权的路由未登录则跳转到登录页
router.beforeEach((to, from, next) => {
  if (to.matched.some((r) => r.meta && r.meta.requiresAuth) && !auth.isAuthenticated) {
    next({ path: '/admin/login', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js